import * as React from "react";
import { SVGProps } from "react";
export const FullscreenOpenIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.375 17.5C3.13889 17.5 2.93403 17.4132 2.76042 17.2396C2.58681 17.066 2.5 16.8611 2.5 16.625V11.625C2.5 11.3889 2.58681 11.184 2.76042 11.0104C2.93403 10.8368 3.13889 10.75 3.375 10.75C3.61111 10.75 3.81597 10.8368 3.98958 11.0104C4.16319 11.184 4.25 11.3889 4.25 11.625V14.5L14.5 4.25H11.625C11.3889 4.25 11.184 4.16319 11.0104 3.98958C10.8368 3.81597 10.75 3.61111 10.75 3.375C10.75 3.13889 10.8368 2.93403 11.0104 2.76042C11.184 2.58681 11.3889 2.5 11.625 2.5H16.625C16.8611 2.5 17.066 2.58681 17.2396 2.76042C17.4132 2.93403 17.5 3.13889 17.5 3.375V8.375C17.5 8.61111 17.4132 8.81597 17.2396 8.98958C17.066 9.16319 16.8611 9.25 16.625 9.25C16.3889 9.25 16.184 9.16319 16.0104 8.98958C15.8368 8.81597 15.75 8.61111 15.75 8.375V5.5L5.5 15.75H8.375C8.61111 15.75 8.81597 15.8368 8.98958 16.0104C9.16319 16.184 9.25 16.3889 9.25 16.625C9.25 16.8611 9.16319 17.066 8.98958 17.2396C8.81597 17.4132 8.61111 17.5 8.375 17.5H3.375Z"
            fill="currentColor"
        />
    </svg>
);
FullscreenOpenIcon.displayName = "FullscreenOpenIcon";
